import * as React from "react";
import { StandardProps } from "@material-ui/core";
import { ButtonBaseProps } from "@material-ui/core/ButtonBase";
import MuiTabs, { TabsProps as MuiTabsProps, TabsClassKey as MuiTabsClassKey, TabsActions } from "@material-ui/core/Tabs";
import { TabIndicatorProps } from "@material-ui/core/Tabs/TabIndicator";
import { withStyles, createStyles, Theme } from './styles';

export interface TabsProps extends StandardProps<ButtonBaseProps, TabsClassKey, 'onChange' | 'action' | 'component'> {
    action?: (actions: TabsActions) => void;
    centered?: boolean;
    children?: React.ReactNode;
    component?: React.ReactType<TabsProps>;
    fullWidth?: boolean;
    indicatorColor?: 'secondary' | 'primary' | string;
    onChange?: (event: React.ChangeEvent<{}>, value: any) => void;
    scrollable?: boolean;
    ScrollButtonComponent?: React.ReactType;
    scrollButtons?: 'auto' | 'on' | 'off';
    TabIndicatorProps?: Partial<TabIndicatorProps>;
    textColor?: 'secondary' | 'primary' | 'inherit' | string;
    value: any;
    width?: string;
    textTransform?: 'initial' | 'uppercase' | 'lowercase' | 'capitalize';
}

export type TabsClassKey = MuiTabsClassKey
    | 'rootUppercase'
    | 'rootLowercase'
    | 'rootCapitalize'
    ;

const styles = () => {

    return createStyles({
        root: {
            textTransform: 'initial'
        },
        rootUppercase: {
            textTransform: 'uppercase'
        },
        rootLowercase: {
            textTransform: 'lowercase'
        },
        rootCapitalize: {
            textTransform: 'capitalize'
        },
    })
};


class Tabs extends React.PureComponent<TabsProps> {

    private renderChildren(c: {}) {
        return React.Children.map(this.props.children, (child: React.ReactElement<any>) => {
            return React.cloneElement(child, {
                classes: c
            })
        })
    }

    render() {
        const { textTransform, classes, color, ...props } = this.props;
        let tabsClasses = {};

        switch (textTransform) {
            case 'lowercase':
                tabsClasses = { root: classes.rootLowercase }
                break;
            case 'uppercase':
                tabsClasses = { root: classes.rootUppercase }
                break;
            case 'capitalize':
                tabsClasses = { root: classes.rootCapitalize }
                break;

            default:
                tabsClasses = { root: classes.root }
        }


        const tabsProps = {
            ...props,
            textColor: this.props.textColor || 'inherit',
        }

        return <MuiTabs {...tabsProps} >
            {this.renderChildren(tabsClasses)}
        </MuiTabs>;
    }
}

export default withStyles(styles)(Tabs);